import { Helmet } from "react-helmet";
import { ABOUT_US } from "../../constants/translations";
import Intro from "./Intro";
import CompanyCommitments from "./CompanyCommitments";
import CompanyPerformance from "./CompanyPerformance";

const AboutUs = () => {
  return (
    <>
      <Helmet>
        <title>{ABOUT_US}</title>
      </Helmet>
      <div className="about-us-page-wrapper">
        <Intro />
        <CompanyCommitments />
        <CompanyPerformance />
      </div>
    </>
  );
};

export default AboutUs;
